import React from 'react';
import { Form, Col, Row, Button, Navbar, Container, Image, Spinner } from 'react-bootstrap';
import axios, { AxiosRequestConfig } from 'axios';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import 'bootstrap/dist/css/bootstrap.min.css';

class UserSettings extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.location.state.user);
        this.state = {
            user: props.location.state.user,
            contractor: props.location.state.contractor,
            input: {
                targetEmail: '',
                Notes:''
            },
            errors: {},
            loading: false,
            emailOptions: [],
            selectedEmails: []
        };
        this.LoadNotification = this.LoadNotification.bind(this);
}

    componentDidMount() {
        this.LoadNotification();
    }

    handleEmailListChange = (e) => {
        const values = Array.from(e.target.selectedOptions, o => o.value);
        this.setState({ selectedEmails: values });
    };

    removeSelectedEmails = () => {
        this.setState(prev => ({
            emailOptions: prev.emailOptions.filter(
                email => !prev.selectedEmails.includes(email)
            ),
            selectedEmails: []
        }));
    };


    addEmailToList = () => {
        const email = (this.state.newEmail || "").trim();

        if (!email) return;

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert("Invalid email format.");
            return;
        }

        this.setState(prev => {
            // Prevent duplicates (case-insensitive)
            const exists = prev.emailOptions.some(
                e => e.toLowerCase() === email.toLowerCase()
            );
            if (exists) {
                alert("This email already exists in the list.");
                return null; // no state change
            }

            return {
                emailOptions: [...prev.emailOptions, email],
                newEmail: "",
                // Optional UX: auto-select the newly added email
                selectedEmails: [...prev.selectedEmails, email]
            };
        });
    };


    CancelNotificationConfig = () => {
        this.props.history.push({
            pathname: '/contractor_portal',
            state: {
                user: this.state.user,
                contractor: this.state.contractor
            }
        });
    }

    saveNotificationEmails = () => {
        // 1. Join the array of emails into a single semicolon-separated string
        const emailListString = this.state.emailOptions.join(';');

        this.setState({ loading: true });

        axios.get(`${Constants.apiURL}/api/Contractor/SaveNotificationEmails`, {
            params: {
                // primary email for lookup
                contactEmail: this.state.contractor.ContactEmail,
                customerName: this.state.contractor.Name,
                // The semicolon-separated list
                notificationEmail: emailListString,
                accessCode: this.state.contractor.Contractor_Portal_Access_Code__c, // Add logic here if you have an access code field
                notes: this.state.input.Notes
            }
        }).then(response => {
            this.setState({ loading: false });
            if (response.status === 200 && response.data === "OK") {
                if (emailListString != '') {
                    alert('Notification email list saved successfully');
                }
                else {
                    alert('No Notification email provided.');
                }
                this.props.history.push({
                    pathname: '/contractor_portal',
                    state: {
                        user: this.state.user,
                        contractor: this.state.contractor
                    }
                });           
            }
            else {
                alert("Error: " + response.data);
            }
        }).catch((error) => {
            this.setState({ loading: false });
            alert(error.message);
        });
    }


    LoadNotification() {
        if (this.state.contractor.Contractor_Portal_Access_Code__c == '')
            return;
        
        axios.get(`${Constants.apiURL}/api/Contractor/LoadContractNotificationEmail`, {
            params: {
                AccessCode: this.state.contractor.Contractor_Portal_Access_Code__c
            }
        }).then(response => {
            console.log(response);
            if (response.status == 200) {
                let a = response.data;
                let emailstr = response.data.notificationEmail || '';
                this.setState({
                    input: 
                    {
                        targetEmail: a.notificationEmail,
                        Notes:a.Notes || ''
                    },
                    emailOptions: emailstr.split(';')
                });
                //alert(this.state.input.targetEmail + ': ' + this.state.input.Notes + ' exists.');

            }
            else {
                alert(this.state.input.targetEmail + ' not found.');
            }
            this.setState({ loading: false });
        }).catch((error) => {
            this.setState({ loading: false });
            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                alert('No notification email');
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                alert('Error contacting server. Please try again soon.')
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }
        });
    }

    render() {
        return (
            <div>
                <SiteMenu user={this.state.user} currentPage='register' />
                <Form onSubmit={this.handleSubmit} noValidate>
                    {/* Wider block */}
                    <Row style={{ padding: '10px', margin: '10px', maxWidth: '1000px' }} className="mb-4">
                        {/* Wider column */}
                        <Col md={8}>
                            <Form.Label style={{ paddingBottom: '24px' }} className="form-header">
                                Contractor Notification Email List
                            </Form.Label><br/>
                            <Form.Label style={{ paddingBottom: '18px' }} >
                                <b>Customer Name:</b> {this.state.contractor.Name}
                            </Form.Label><br />
                            <Form.Label style={{ paddingBottom: '18px' }} >
                                <b>Default Notification Email:</b> {this.state.contractor.ContactEmail}
                            </Form.Label>

                            {/* Add Email */}
                            <Form.Group className="mb-4">
                                <Form.Label style={{ fontWeight: 'bold' }}>
                                    Add Email to List
                                </Form.Label>

                                <Row>
                                    {/* Wider Textbox */}
                                    <Col md={8}>
                                        <Form.Control
                                            type="email"
                                            placeholder="Add new email"
                                            value={this.state.newEmail}
                                            onChange={(e) => this.setState({ newEmail: e.target.value })}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    this.addEmailToList();
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                    </Col>

                                    {/* Add Button on right */}
                                    <Col md={2}>
                                        <Button
                                            variant="success"
                                            className="w-100"
                                            onClick={this.addEmailToList}
                                        >
                                            Add
                                        </Button>
                                    </Col>
                                </Row>
                            </Form.Group>

                            {/* Email List */}
                            <Form.Group className="mb-4">
                                <Form.Label style={{ fontWeight: 'bold' }}>
                                    Additional Notification Email List
                                </Form.Label>

                                {/* ListBox row */}
                                <Row>
                                    <Col md={8}>
                                        <Form.Control
                                            as="select"
                                            multiple
                                            size={6}
                                            value={this.state.selectedEmails}
                                            onChange={this.handleEmailListChange}
                                        >
                                            {this.state.emailOptions.map(email => (
                                                <option key={email} value={email}>
                                                    {email}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Col>
                                </Row>

                                {/* Remove button on its own row */}
                                <Row className="mt-2">
                                    <Col md={4}>
                                        <Button 
                                            variant="danger"
                                            className="w-100"
                                            onClick={this.removeSelectedEmails}
                                            disabled={this.state.selectedEmails.length === 0}>Remove Selected
                                        </Button>
                                    </Col>
                                    <Col md={2} >
                                        <Button 
                                            style={{ backgroundColor: '#1F419B'}}
                                            variant="primary"
                                            onClick={this.saveNotificationEmails}>Save
                                        </Button>
                                    </Col>
                                    <Col md={2} >
                                        <Button
                                            style={{ backgroundColor: '#1F419B', alignItems: 'right' }}
                                            variant="secondary"
                                            onClick={this.CancelNotificationConfig}>Cancel
                                        </Button>
                                    </Col></Row>
                            </Form.Group>

                        </Col>
                    </Row>

                   
                </Form>
            </div>
        );
    }
}


export default UserSettings;